/**
 * @file 版本管理
 * @author lixiaobin
 */

import { postWithJson } from 'library/utils/serviceUtil'

/**
 * 版本列表
 * @param {PageDto} params.pageDto 分页信息
 */
export const getList = (params = {}) => {
    return postWithJson('/version/list.np', params)
}

/**
 * 版本详情
 * @param {PageDto} params.pageDto 分页信息
 */
export const menuDetail = (params = {}) => {
    return postWithJson('/version/menu/detail.np', params)
}

/**
 * 版本详情
 * @param {PageDto} params.pageDto 分页信息
 */
export const set = (params = {}) => {
    return postWithJson('/version/menu/set.np', params)
}
